<script lang="ts" setup>
import { computed } from "vue";
import { useShortCount } from "@/use/common";

const props = defineProps<{
  label: string;
  count?: number;
}>();

const text = computed(
  () => `${props.label}${props.count ? ` (${useShortCount(props.count)})` : ""}`
);
</script>
<template>
  <span class="btn btn-xs">
    {{ text }}
  </span>
</template>
